import { sendRequest } from "../request";
const BASE_URL = '/api/projectsTimeline';

export function createProject(data) {
    return sendRequest(`${BASE_URL}/createProject`, 'POST', data, 'Unable to create project');
}

export function getProjects(user) {
    return sendRequest(`${BASE_URL}/getProjects/${user._id}`);
}

export function getClientProjects(user, clientID) {
    return sendRequest(`${BASE_URL}/getClientProjects/${user._id}/${clientID}`);
}

export function updateProject(projectID, data) {
    return sendRequest(`${BASE_URL}/updateProject/${projectID}`, 'PUT', data, 'Unable to update project');
}

export function findProject(projectNumber){
    return sendRequest(`${BASE_URL}/findProject/${projectNumber}`)
}

export function findProjects(user, searchQuery){
    return sendRequest(`${BASE_URL}/findProjects/${user._id}/${searchQuery}`)
}